/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type IconSmall16ArrowLeftIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function IconSmall16ArrowLeftIcon(props: IconSmall16ArrowLeftIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 16 16"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M11 15a1 1 0 01-.707-.293l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L6.414 8l5.293 5.293A1 1 0 0111 15z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  );
}

export default IconSmall16ArrowLeftIcon;
/* prettier-ignore-end */
